import { Link } from "react-router-dom";
import styles from "./layout.module.css";
import { Link as MuiLink } from "@mui/material";
import { TuneOutlined, CalendarTodayOutlined, SendOutlined, LocalShippingOutlined, PeopleOutlineOutlined, PersonOutlineOutlined, SettingsOutlined, InventoryOutlined, AssessmentOutlined, Close } from "@mui/icons-material";
import { authData } from "./GetAuth";
import { useEffect, useRef } from "react";
import { useState } from "react";
import { useWebsite } from "../../context/WebsiteContext";

// Desktop shows submenus as flyouts; below this width they are inline accordions
const isDesktop = () => window.matchMedia('(min-width: 992px)').matches;

const Footer = ({ menuName, mobileOpen, onClose }) => {
  const auth = authData();
  const [currentSubscription, setCurrentSubscription] = useState(0);
  const [openMenus, setOpenMenus] = useState([]);
  const [dropUp, setDropUp] = useState(null);
  const footerRef = useRef(null);

  useEffect(() => {
    if (auth && auth?.subscription && auth?.subscription?.id) {
      setCurrentSubscription(auth?.subscription?.id);
    }
  }, [auth]);

  // Close the desktop flyout when clicking anywhere outside the sidebar
  useEffect(() => {
    const handleOutside = (e) => {
      if (isDesktop() && footerRef.current && !footerRef.current.contains(e.target)) {
        setOpenMenus([]);
      }
    };
    document.addEventListener('mousedown', handleOutside);
    return () => document.removeEventListener('mousedown', handleOutside);
  }, []);

  // Open the flyout upward when there is not enough room below the menu item
  const placeMenu = (name, li) => {
    const list = li && li.querySelector('ul');
    if (!list) return;
    const rect = li.getBoundingClientRect();
    const spaceBelow = window.innerHeight - rect.top;
    const spaceAbove = rect.bottom;
    setDropUp(list.offsetHeight > spaceBelow - 8 && spaceAbove > spaceBelow ? name : null);
  };

  const openFlyout = (name, li) => {
    setOpenMenus([name]);
    placeMenu(name, li);
  };

  const menuProps = (name) => ({
    onMouseEnter: (e) => isDesktop() && openFlyout(name, e.currentTarget),
    onMouseLeave: () => isDesktop() && setOpenMenus([]),
  });

  const toggleMenu = (name, e) => {
    if (isDesktop()) {
      openFlyout(name, e.currentTarget.closest('li'));
      return;
    }
    setOpenMenus((prev) => (
      prev.includes(name) ? prev.filter((m) => m !== name) : [...prev, name]
    ));
  };

  const closeAll = () => {
    setOpenMenus([]);
    onClose && onClose();
  };

  const { websiteData, currentDomain } = useWebsite();

  return (<>
    <div
      className={`${styles.SidebarOverlay} ${mobileOpen ? styles.MobileOpen : ''}`}
      onClick={onClose}
      aria-hidden="true"
    />
    <footer ref={footerRef} className={`${styles.FooterMain} ${mobileOpen ? styles.MobileOpen : ''}`}>
      <div className={`${styles.SideAvatarMain}`}>
        <Link to={"/dashboard"} onClick={closeAll}><img src={websiteData && websiteData?.home_config && websiteData?.home_config?.logoURL ? websiteData?.home_config?.logoURL : "/favicon.png"} alt="" style={{ maxWidth: '65px' }} /></Link>
        <button type="button" className={`${styles.SideCloseBU}`} onClick={onClose} aria-label="Close navigation">
          <Close style={{ color: '#85859e', width: 18, height: 18 }} />
        </button>
      </div>

      <div className={`${styles.SideMenuLinkSec}`}>
        <div className={`${styles.SideMenuLinkSecUnder}`}>
          <ul>
            {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('dashboard:view') > -1) && <li {...menuProps('dashboard')} className={`${styles.DropDownSec} ${menuName === 'dashboard' ? styles.Active : ''} ${openMenus.includes('dashboard') ? styles.Open : ''} ${dropUp === 'dashboard' ? styles.DropUp : ''}`}>
              <MuiLink onClick={(e) => toggleMenu('dashboard', e)}>
                <TuneOutlined />
                <p className={`${styles.SideLinkText}`}>Dashboard</p>
              </MuiLink>
              <ul className={`${styles.DropDownList}`}>
                <li><Link to={"/dashboard"} onClick={closeAll}>Overview</Link></li>
                {/*currentSubscription > 2 && <li><Link to={"/dashboard/live-drivers"} onClick={closeAll}>Live Drivers</Link></li>*/}
              </ul>
            </li>}
            {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:list') > -1 || auth?.permissions?.indexOf('bookings:create') > -1 || auth?.permissions?.indexOf('bookings:assign-driver') > -1 || auth?.permissions?.indexOf('bookings:driver-jobs') > -1 || auth?.permissions?.indexOf('bookings:picked-items') > -1) && <li {...menuProps('booking')} className={`${styles.DropDownSec} ${menuName === 'booking' ? styles.Active : ''} ${openMenus.includes('booking') ? styles.Open : ''} ${dropUp === 'booking' ? styles.DropUp : ''}`}>
              <MuiLink onClick={(e) => toggleMenu('booking', e)}>
                <CalendarTodayOutlined />
                <p className={`${styles.SideLinkText}`}>Bookings</p>
              </MuiLink>
              <ul className={`${styles.DropDownList}`}>
                {auth?.user_type !== 1 && (auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:create') > -1) && <li><Link to={"/booking/add-booking"} onClick={closeAll}>Make A Booking</Link></li>}
                {auth?.user_type !== 1 && (auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:create') > -1) && <li><Link to={"/booking/add-delivery-booking"} onClick={closeAll}>Make A Delivery Booking</Link></li>}
                {auth?.user_type !== 1 && (auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:assign-driver') > -1) && <li><Link to={"/booking/assign-drivers"} onClick={closeAll}>Assign Bookings To Driver</Link></li>}
                {(auth?.user_type === 1 || (auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:list') > -1)) && <li><Link to={"/booking/list"} onClick={closeAll}>View All Bookings</Link></li>}
                {auth?.user_type !== 1 && (auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:driver-jobs') > -1) && <li><Link to={"/booking/driver-jobs"} onClick={closeAll}>View Driver Jobs</Link></li>}
                {auth?.user_type !== 1 && (auth?.user_type === 2 || auth?.permissions?.indexOf('bookings:picked-items') > -1) && <li><Link to={"/booking/picked-items"} onClick={closeAll}>View Picked Items</Link></li>}
              </ul>
            </li>}
            {currentSubscription > 2 && (auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('shipping:container-list') > -1 || auth?.permissions?.indexOf('shipping:list') > -1 || auth?.permissions?.indexOf('shipping:add') > -1) && <li {...menuProps('shipping')} className={`${styles.DropDownSec} ${menuName === 'shipping' ? styles.Active : ''} ${openMenus.includes('shipping') ? styles.Open : ''} ${dropUp === 'shipping' ? styles.DropUp : ''}`}>
              <MuiLink onClick={(e) => toggleMenu('shipping', e)}>
                <SendOutlined />
                <p className={`${styles.SideLinkText}`}>Shippings</p>
              </MuiLink>
              <ul className={`${styles.DropDownList}`}>
                {(auth?.user_type === 1 || (auth?.user_type === 2 || auth?.permissions?.indexOf('shipping:container-list') > -1)) && <li><Link to={"/shipping/container-list"} onClick={closeAll}>Containers</Link></li>}
                {auth?.user_type !== 1 && (auth?.user_type === 2 || auth?.permissions?.indexOf('shipping:add') > -1) && <li><Link to={"/shipping/add"} onClick={closeAll}>Add Shipping</Link></li>}
                {(auth?.user_type === 1 || (auth?.user_type === 2 || auth?.permissions?.indexOf('shipping:list') > -1)) && <li><Link to={"/shipping/list"} onClick={closeAll}>View All Shippings</Link></li>}
              </ul>
            </li>}
            {currentSubscription > 2 && (auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('delivery:receive-shipping') > -1 || auth?.permissions?.indexOf('delivery:assign-driver') > -1 || auth?.permissions?.indexOf('delivery:driver-jobs') > -1) && <li {...menuProps('delivery')} className={`${styles.DropDownSec} ${menuName === 'delivery' ? styles.Active : ''} ${openMenus.includes('delivery') ? styles.Open : ''} ${dropUp === 'delivery' ? styles.DropUp : ''}`}>
              <MuiLink onClick={(e) => toggleMenu('delivery', e)}>
                <LocalShippingOutlined />
                <p className={`${styles.SideLinkText}`}>Delivery</p>
              </MuiLink>
              <ul className={`${styles.DropDownList}`}>
                {(auth?.user_type === 2 || auth?.permissions?.indexOf('delivery:receive-shipping') > -1) && <li><Link to={"/delivery/receive-shipping"} onClick={closeAll}>Receive Shipping</Link></li>}
                {(auth?.user_type === 2 || auth?.permissions?.indexOf('delivery:assign-driver') > -1) && <li><Link to={"/delivery/assign-to-driver"} onClick={closeAll}>Assign Booking For Delivery</Link></li>}
                {(auth?.user_type === 2 || auth?.permissions?.indexOf('delivery:driver-jobs') > -1) && <li><Link to={"/delivery/driver-jobs"} onClick={closeAll}>View Driver Job For Delivery</Link></li>}
              </ul>
            </li>}
            {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('customers:list') > -1) && <li className={menuName === "customer" ? `${styles.Active}` : ``}>
              <Link to={"/customer/list"} onClick={closeAll}>
                <PersonOutlineOutlined />
                <p className={`${styles.SideLinkText}`}>Customers</p>
              </Link>
            </li>}
            {currentSubscription > 2 && (auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('drivers:list') > -1) && <li className={menuName === "driver" ? `${styles.Active}` : ``}>
              <Link to={"/driver/list"} onClick={closeAll}>
                <PeopleOutlineOutlined />
                <p className={`${styles.SideLinkText}`}>Drivers</p>
              </Link>
            </li>}
            {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('items:list') > -1) && <li {...menuProps('items')} className={`${styles.DropDownSec} ${menuName === 'items' ? styles.Active : ''} ${openMenus.includes('items') ? styles.Open : ''} ${dropUp === 'items' ? styles.DropUp : ''}`}>
              <MuiLink onClick={(e) => toggleMenu('items', e)}>
                <InventoryOutlined />
                <p className={`${styles.SideLinkText}`}>Items</p>
              </MuiLink>
              <ul className={`${styles.DropDownList}`}>
                <li><Link to={"/delivery-product-category/list"} onClick={closeAll}>Delivery Item Categories</Link></li>
                <li><Link to={"/delivery-product/list"} onClick={closeAll}>Delivery Items</Link></li>
                <li><Link to={"/product-category/list"} onClick={closeAll}>PIckup Item Categories</Link></li>
                <li><Link to={"/product/list"} onClick={closeAll}>PIckup Items</Link></li>
              </ul>
            </li>}
            {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('report:driver-report') > -1 || auth?.permissions?.indexOf('report:container-report') > -1 || auth?.permissions?.indexOf('report:customer-orders') > -1 || auth?.permissions?.indexOf('report:payment-report') > -1 || auth?.permissions?.indexOf('report:user-tracking-report') > -1) && <li {...menuProps('report')} className={`${styles.DropDownSec} ${menuName === 'report' ? styles.Active : ''} ${openMenus.includes('report') ? styles.Open : ''} ${dropUp === 'report' ? styles.DropUp : ''}`}>
              <MuiLink onClick={(e) => toggleMenu('report', e)}>
                <AssessmentOutlined />
                <p className={`${styles.SideLinkText}`}>Reports</p>
              </MuiLink>
              <ul className={`${styles.DropDownList}`}>
                {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('report:driver-report') > -1) && <li><Link to={"/report/driver-report"} onClick={closeAll}>Driver Report</Link></li>}
                {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('report:container-report') > -1) && <li><Link to={"/report/container-report"} onClick={closeAll}>Container Report</Link></li>}
                {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('report:customer-orders') > -1) && <li><Link to={"/report/customer-orders"} onClick={closeAll}>Customer Orders</Link></li>}
                {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('report:payment-report') > -1) && <li><Link to={"/report/payment-report"} onClick={closeAll}>Payment Report</Link></li>}
                {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('report:user-tracking-report') > -1) && <li><Link to={"/report/user-tracking-report"} onClick={closeAll}>User Tracking Report</Link></li>}
              </ul>
            </li>}
            {(auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('settings:membership-list') > -1 || auth?.permissions?.indexOf('settings:user-list') > -1 || auth?.permissions?.indexOf('settings:user-role-list') > -1 || auth?.permissions?.indexOf('settings:user-permission') > -1) && <li {...menuProps('settings')} className={`${styles.DropDownSec} ${menuName === 'settings' ? styles.Active : ''} ${openMenus.includes('settings') ? styles.Open : ''} ${dropUp === 'settings' ? styles.DropUp : ''}`}>
              <MuiLink onClick={(e) => toggleMenu('settings', e)}>
                <SettingsOutlined />
                <p className={`${styles.SideLinkText}`}>Settings</p>
              </MuiLink>
              <ul className={`${styles.DropDownList}`}>
                {auth?.user_type === 1 && <li><Link to={"/company/list"} onClick={closeAll}>Company Management</Link></li>}
                {auth?.user_type === 1 && <li><Link to={"/subscription/list"} onClick={closeAll}>Subscription Management</Link></li>}
                {/*currentSubscription > 3 && (auth?.user_type !== 1 || (auth?.user_type === 2 || auth?.permissions?.indexOf('settings:membership-list') > -1)) && <li><Link to={"/membership/list"} onClick={closeAll}>Membership Management</Link></li>*/}
                {(auth?.user_type === 2 || auth?.permissions?.indexOf('settings:user-list') > -1) && <li><Link to={"/user/list"} onClick={closeAll}>User Management</Link></li>}
                {(auth?.user_type === 1 || auth?.user_type === 2) && <li><Link to={"/email-template/list"} onClick={closeAll}>Email Templates</Link></li>}
                {currentSubscription > 2 && (auth?.user_type === 2 || auth?.permissions?.indexOf('settings:user-role-list') > -1) && <li><Link to={"/user-role/list"} onClick={closeAll}>User Roles</Link></li>}
                {currentSubscription > 2 && (auth?.user_type === 1 || auth?.user_type === 2 || auth?.permissions?.indexOf('settings:user-permission') > -1) && <li><Link to={"/user-permissions"} onClick={closeAll}>User Permissions</Link></li>}
                {auth?.user_type === 2 && <li><Link to={"/company-profile"} onClick={closeAll}>Company Settings</Link></li>}
              </ul>
            </li>}
          </ul>
        </div>
      </div>
    </footer>
  </>);
};

export default Footer;